// src/redux/slices/submitOrderSlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://moga-dev.com/api';

export const submitOrderNew = createAsyncThunk(
  "submitOrderNew/submit",
  async (orderData, { rejectWithValue, getState }) => {
    try {
      const userId = orderData.user_id || getState().auth.user?.id;
      const cityId = getState().citySelection.selectedCity?.id;

      if (!userId) {
        return rejectWithValue("User not authenticated");
      }

      const payload = { ...orderData, user_id: userId };

      const response = await axios.post(`${baseUrl}/submit-order-new`, payload, {
        headers: {
          "Content-Type": "application/json",
          cityId: cityId || undefined,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred during order submission");
    }
  }
);

const submitOrderSlice = createSlice({
  name: "submitOrderNew",
  initialState: {
    loading: false,
    error: null,
    orderResponse: null,
  },
  reducers: {
    clearSubmitOrderState: (state) => {
      state.loading = false;
      state.error = null;
      state.orderResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitOrderNew.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitOrderNew.fulfilled, (state, action) => {
        state.loading = false;
        state.orderResponse = action.payload;
      })
      .addCase(submitOrderNew.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Order submission failed";
      });
  },
});

export const { clearSubmitOrderState } = submitOrderSlice.actions;
export default submitOrderSlice.reducer;

// Selectors
export const selectSubmitOrderLoading = (state) => state.submitOrderNew.loading;
export const selectSubmitOrderError = (state) => state.submitOrderNew.error;
export const selectSubmitOrderResponse = (state) => state.submitOrderNew.orderResponse;
